import React from "react"
import { connect } from "react-redux"
import { blockUi, unBlockUi } from "../../../../actions/actionCreator"
import { aemHostClient, eapiClient, taxonomyHostClient } from "../../../../restClient"
import { isEmptyObject, Translations } from "../../../../utils"
import SweepInstructionsList from "../../../CaseBody/ProductRequests/CaptureProductGlsCashCon/SweepInstructionsList"
import "./index.css"

class CashConcentrationSummary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isCustAck: false,
            allSweepInstructions: {},
            availableAccountsList: [],
            sowCashConcentrationSummaryPageJson: {},
            countryAccountList: [],
            sweepTypes: [],
            miscBillingAccordionIndex: 0,
            billingDetails: []
        }
    }

    isReadOnly = () => {
        const { customer, caseMenu } = this.props || {}
        return customer && (customer.roleDetails.customer || this.state.isCustAck) ||
            (caseMenu && caseMenu.isEditing &&
                (caseMenu.editingUserEmail !== customer.emailAddress))
    }

    isCustomer = () => {
        return this.props.customer && this.props.customer.roleDetails.customer
    }

    componentWillMount() {
        if (this.props.savedSow.statusValue === 'Acknowledged By Customer' || this.props.savedSow.statusValue === 'Sent to Implementation Manager') {

            this.setState({ isCustAck: true });
        }
        this.getSowCashConcentrationSummaryPageJson()
        this.getSweepInstructionList()
        this.getTaxanomyUrl()
    }
    getTaxanomyUrl = () => {
        //this.taxanomyURL = this.translations(this.state.pageJson.par.aemform_sweepAccounts.glsCashConTaxonomy);
        taxonomyHostClient('/product/taxonomies/sweepType')
            .then(({ data }) => {
                this.setState({ sweepTypes: data.responseData.classificationNodes });
            });
    }

    getTranslation = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }
    handleSaveAndReturn = () => {
        this.navigateToSowBody()
    }

    navigateToSowBody = () => {
        this.props.history.push({ pathname: "/sow-body", state: { updateGLSTabStatus: true } });
    }

    handleAddSweepInstruction = () => {
        const { glsId } = (this.props.match && this.props.match.params) || {}
        if (glsId) {
            const apiUrl = `/sows/${glsId}/glses`
            const payload = {
                cashConcentration: {
                    sweepInstructions: [{}]
                }
            }
            eapiClient(apiUrl, {
                method: 'PUT',
                data: JSON.stringify(payload)
            })
                .then(({ data }) => {
                    if (data.responseData) {
                        this.getSweepInstructionList()
                    }

                })
        }
    }

    getSweepInstructionList = () => {
        const { savedSow } = this.props || {}
        const { glsId } = (this.props.match && this.props.match.params) || {}
        if (savedSow && glsId) {
            const apiUrl = `/sows/${savedSow.sowId}/getAllSweepInstructions/${glsId}`
            this.props.blockUi && this.props.blockUi()
            eapiClient(apiUrl)
                .then(({ data }) => {
                    if (data.responseData) {
                        this.setState({
                            allSweepInstructions: data.responseData,
                            billingDetails: (data.responseData.billingDetails && data.responseData.billingDetails.length && data.responseData.billingDetails)
                                || [{ ...this.billingAccountObj }]
                        })
                        this.props.unBlockUi && this.props.unBlockUi()
                    }

                })
        }
    }

    handleDeleteSweepInstruction = (sweepObj) => {
        const { glsId } = this.props.match.params
        if (glsId && sweepObj.id) {
            const apiUrl = `/sows/${glsId}/deleteSweep/${sweepObj.id}`
            eapiClient(apiUrl, {
                method: "DELETE"
            })
                .then(({ data }) => {
                    if (data.responseData) {
                        this.getSweepInstructionList()
                    }

                })
        }
    }

    getSowCashConcentrationSummaryPageJson = () => {
        aemHostClient('/aemData/formData/json_sow-sweep-instructions-panel').then(({ data }) => {
            if (data) {
                this.setState({
                    sowCashConcentrationSummaryPageJson: data
                })
            }
        })
    }

    getSweepDetailsById = (sweepId) => {
        const { glsId } = (this.props.match && this.props.match.params) || {}
        const apiUrl = `/sows/${glsId}/getSweepDetail/${sweepId}`
        return eapiClient(apiUrl).then(({ data }) => {
            if (data.responseData) {
                return data.responseData
            }
        })
    }

    updateSweepdetails = (sweepInstructionData, toSweepId) => {
        const { glsId } = (this.props.match && this.props.match.params) || {}
        const apiUrl = `/sows/${glsId}/glses`
        const payload = {
            cashConcentration: {
                sweepInstructions: [this.getFormattedCopySweepInstructionData({ ...sweepInstructionData }, toSweepId)]
            }
        }
        eapiClient(apiUrl, {
            method: 'PUT',
            data: JSON.stringify(payload)
        })
            .then(({ data }) => {
                this.getSweepInstructionList()
            });
    }

    handleCopySweepFrom = async (e, toSweepId) => {
        const { target } = e || {}
        if (target.value) {
            const fromSweepData = await this.getSweepDetailsById(target.value)
            if (fromSweepData && fromSweepData[0]) {
                this.updateSweepdetails(fromSweepData[0], toSweepId)
            }
        }
    }

    getFormattedCopySweepInstructionData = (sweepInstructionData = {}, toSweepId) => {
        if (sweepInstructionData.ccrInfo) {
            sweepInstructionData.ccrInfo.ccrRefId = " "
            if (sweepInstructionData.ccrInfo.interestEarnTierStatus === "incremental" || sweepInstructionData.ccrInfo.interestEarnTierStatus === "cumulative") {
                Array.isArray(sweepInstructionData.ccrInfo.interestEarnTiers) && sweepInstructionData.ccrInfo.interestEarnTiers.length &&
                    sweepInstructionData.ccrInfo.interestEarnTiers.forEach(tier => {
                        if (!isEmptyObject(tier)) {
                            delete tier.id
                            delete tier.lastUpdatedOn
                            delete tier.tierRefId

                        }
                    })
            }
            if (sweepInstructionData.ccrInfo.interestChargesTierStatus === "incremental" || sweepInstructionData.ccrInfo.interestChargesTierStatus === "cumulative") {
                Array.isArray(sweepInstructionData.ccrInfo.interestChargeTiers) && sweepInstructionData.ccrInfo.interestChargeTiers.length &&
                    sweepInstructionData.ccrInfo.interestChargeTiers.forEach(tier => {
                        if (!isEmptyObject(tier)) {
                            delete tier.id
                            delete tier.lastUpdatedOn
                            delete tier.tierRefId

                        }
                    })
            }
        }
        if (sweepInstructionData.sweepParticipantsAccounts && sweepInstructionData.sweepParticipantsAccounts.subAccount) {
            sweepInstructionData.sweepParticipantsAccounts.subAccount = ''
            delete sweepInstructionData.accountInterestLimits
            return { ...sweepInstructionData, id: toSweepId, }
        }
        return {
            ...sweepInstructionData,
            id: toSweepId,
        }
    }

    getAccountList = () => {
        return Array.isArray(this.state.allSweepInstructions.accountList) && this.state.allSweepInstructions.accountList.map(el =>
            ({ ...el, accountHolder: { name: this.props.sowAgent.entityName }, country: el.location })) || []
    }

    getSweepItems = () => {
        return (this.state.allSweepInstructions && this.state.allSweepInstructions.sweepDetails
            && this.state.allSweepInstructions.sweepDetails.map(el => ({ ...el, ...el.sweepInstructions, status: el.status }))) || []
    }

    getBillingDetails = () => {
        return this.state.sowCashConcentrationSummaryPageJson &&
            this.state.sowCashConcentrationSummaryPageJson.par &&
            this.state.sowCashConcentrationSummaryPageJson.par.billingItemObject && this.state.billingDetails && !this.state.billingDetails.length ?
            [this.state.sowCashConcentrationSummaryPageJson.par.billingItemObject] : this.state.billingDetails
    }

    // handleUpdateBilling = (callback) => {
    //     const { glsId } = (this.props.match && this.props.match.params) || {}
    //     const apiUrl = `/sows/${glsId}/glses/sow_bill`
    //     const payload = {
    //         billingDetails: this.state.billingDetails
    //     }
    //     this.props.blockUi && this.props.blockUi()
    //     eapiClient(apiUrl, {
    //         method: 'PUT',
    //         data: JSON.stringify(payload)
    //     }).then(({ data }) => {
    //         this.props.unBlockUi && this.props.unBlockUi()
    //         this.getSweepInstructionList();
    //         callback && callback()
    //     })
    // }

    getMasterAndSubAccounts = () => {
        const accArray = []
        this.getSweepItems().map(item => {
            if (!isEmptyObject(item.masterAccount) && accArray.findIndex(acc => acc.id === item.masterAccount.id) < 0) {
                accArray.push(this.getFormattedDropdownAccountLabel(item.masterAccount))
            }
            if (!isEmptyObject(item.subAccount) && accArray.findIndex(acc => acc.id === item.subAccount.id) < 0) {
                accArray.push(this.getFormattedDropdownAccountLabel(item.subAccount))
            }
        })
        return accArray
    }

    getFormattedDropdownAccountLabel = (acc = {}) => {
        const { accountNumber, location, currency, sowEntityId, countryOfIncorporation } = acc
        const { registeredName } = (this.props.savedSow && this.props.savedSow.entity && this.props.savedSow.entity.find(en => en.id === sowEntityId)) || {}
        return { id: acc.id, accountNumber, country: (typeof location === "string" ? countryOfIncorporation : location), currency, bic: (typeof location === "string" ? location : ''), entityName: registeredName }
    }

    handleBillingFormChange = (formData = {}, billingAccountIndex) => {
        const newBillingDetails = [...this.state.billingDetails] || []
        if (newBillingDetails[billingAccountIndex]) {
            newBillingDetails[billingAccountIndex] = { ...formData }
            this.setState({ billingDetails: newBillingDetails })
        }
    }

    render() {
        return (<article className="form-container">
            <h2 className="gdocs-text-align-center">Cash Concentration (Summary)</h2>
            <strong>Sweep instructions</strong>
            <section className="add-sweep-instructions">
                <button className="gdocs-btn-default" disabled={this.isReadOnly()} onClick={(e) => {
                    e.preventDefault()
                    this.handleAddSweepInstruction()
                }}><i className="icon icon-add"></i>
                    {
                        this.getTranslation((this.state.sowCashConcentrationSummaryPageJson && this.state.sowCashConcentrationSummaryPageJson.par &&
                            this.state.sowCashConcentrationSummaryPageJson.par.staticText_sweepInstructions &&
                            this.state.sowCashConcentrationSummaryPageJson.par.staticText_sweepInstructions.addSweepBtnText) || "Add Sweep Instructions")
                    }
                </button>
            </section>
            <section className="sweep-list">
                <SweepInstructionsList
                    items={this.getSweepItems()}
                    accounts={this.getMasterAndSubAccounts()}
                    pageJson={this.state.sowCashConcentrationSummaryPageJson.par}
                    _onClick={(sweepObj) => {
                        const { glsId } = (this.props.match && this.props.match.params) || {}
                        if (sweepObj && sweepObj.id && glsId) {
                            this.props.history.push(`/sow-body/capture-sweep-instructions/${glsId}/${sweepObj.id}`)
                        }
                    }}
                    accountList={this.state.countryAccountList}
                    lang={this.props.lang}
                    sweepTypes={this.state.sweepTypes}
                    disabled={this.props.customer.roleDetails.customer}
                    _onDelete={(sweepObj) => { this.handleDeleteSweepInstruction(sweepObj) }}
                    copySweepFrom={true}
                    handleCopySweepFrom={this.handleCopySweepFrom}
                    sowAgent={this.props.sowAgent}
                    listType="sow-sweep"
                    customer={this.props.customer}
                    sow
                    isCustAck={this.state.isCustAck}
                    caseMenu={this.props.caseMenu}
                />
            </section>
            {/* <section className="sow-misc-billing">
                <NavListAccordionWrapper open={this.state.miscBillingAccordionIndex == 0}
                    key={"entity-" + 0}
                > */}
            {/* <NavListAccordion
                        lang={this.props.lang.currentLang.lang}
                        navAccHeading={`Miscellaneous`}
                        status={"incomplete"}
                        _onClick={() => this.setState({ miscBillingAccordionIndex: 0 })}
                    >
                        <SowCashConMisc />
                        <h3>SOW Cash Con Misc</h3>
                    </NavListAccordion> */}
            {/* <NavListAccordion
                        lang={this.props.lang.currentLang.lang}
                        navAccHeading={`Billing`}
                        status={this.state.allSweepInstructions && this.state.allSweepInstructions.billingStatus}
                        _onClick={() => this.setState({ miscBillingAccordionIndex: 1 })}
                    >
                        <CashConBilling
                            formJson={this.state.sowCashConcentrationSummaryPageJson.par}
                            sowAgent={this.props.sowAgent}
                            lang={this.props.lang}
                            accountList={this.getAccountList()}
                            getSweepInstructionList={this.getSweepInstructionList}
                            handleBillingFormChange={this.handleBillingFormChange}
                            handleUpdateBilling={this.handleUpdateBilling}
                            history={this.props.history}
                            customer={this.props.customer.roleDetails.customer}
                            isCustAck={this.state.isCustAck}
                            billingDetails={this.getBillingDetails()}
                            handleAddDelAccount={(accounts = []) => {
                                this.setState({
                                    billingDetails: accounts
                                })
                            }}
                            isReadOnly={this.isReadOnly}
                        />
                    </NavListAccordion> */}
            {/* </NavListAccordionWrapper>
            </section> */}
            <section className="sow-cash-con-back">
                {this.isCustomer() ?
                    <button
                        onClick={() => { this.navigateToSowBody() }} className="gdocs-btn-submit"                        >
                        {
                            this.getTranslation((this.state.sowCashConcentrationSummaryPageJson && this.state.sowCashConcentrationSummaryPageJson.par &&
                                this.state.sowCashConcentrationSummaryPageJson.par.back) || "Back")
                        }
                    </button>
                    :
                    <button
                        onClick={() => this.handleSaveAndReturn()} className="gdocs-btn-submit" disabled={this.isReadOnly()}                    >
                        {
                            this.getTranslation((this.state.sowCashConcentrationSummaryPageJson && this.state.sowCashConcentrationSummaryPageJson.par &&
                                this.state.sowCashConcentrationSummaryPageJson.par.saveAndReturn) || "Save and return")
                        }
                    </button>
                }
            </section>
        </article>)
    }

}

const mapStateToProps = state => {
    return {
        customer: state.auth.userDetails,
        lang: state.lang,
        sowAgent: state.sowEntities.sowAgent || {},
        savedSow: state.sowEntities.savedSow,
        caseMenu: state.caseMenuInfo
    }
}

const mapDispatchToProps = dispatch => {
    return {
        blockUi: () => {
            dispatch(blockUi())
        },
        unBlockUi: () => {
            dispatch(unBlockUi())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CashConcentrationSummary)


// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/CashConcentrationSummary/index.js